import React, { useEffect, useState } from 'react';
import SelectInput from '../../../../components/Basic/Inputs/SelectWithInput';
import MarketWbApi from '../../../../API/market/wb-api';

export default function WbCategorySelect({ category = '', onChange = () => { }, style, label = "Категория вб", ...props }) {
  const [list, setList] = useState([]);
  const [value, setValue] = useState('');
  const [isOk, setIsOk] = useState(null);

  const findCategory = (search) => {
    MarketWbApi.getCategories({ data: { search } }).then((r) => {
      const categories = r.categories;
      setList(categories);
      if (r.matchedCategory) {
        setIsOk(true);
      } else {
        setIsOk(false);
      }
    });
  };

  const onSelect = (v) => {
    //  setValue(v);
    onChange(v);
    setIsOk(null);
  };

  const onBlur = () => {
    if (isOk) {
      onSelect(value);
      //setIsOk(null);
    }
  };

  const deleteCategory = () => {
    onChange('');
    setIsOk(null);
  };

  useEffect(() => {

    setValue(category);
  }, [category]);

  const onChangeInput = (v) => {
    if (v.length === 0) {
      //onChange('');
    }
    setValue(v);
    findCategory(v);
  };

  return (
    <SelectInput
      select={value}
      list={list}
      add={false}
      preventState={true}
      addText={'Добавить'}
      defaultText={'Без категории'}
      placeholder={label}
      {...props}
      isOk={isOk}
      onBlur={onBlur}
      onChange={onChangeInput}
      onSelect={onSelect}
      deletePlace={deleteCategory}
      onFocus={(v) => findCategory(v)}
    />
  );
}
